export enum DashboardSectionType {
  Details = 'details',
  Visibility = 'visibility',
  SavedReports = 'reports',
  Filters = 'filters',
  Translations = 'translations'
}
